import type { IPoint } from '@/modules/Editor/point'
import { action } from '@/modules/Editor/utils/workers/fromWorker'

import { polygonToRaster } from '@/modules/Editor/plugins/mask/utils/polygonToRaster'
import { Actions } from './types'
import type { DFSParams } from '@/modules/Editor/plugins/fill/runDFSScan'
import { runDFSScan } from '@/modules/Editor/plugins/fill/runDFSScan'

action<{ path: IPoint[] }>(Actions.polygonToRaster, (payload: { path: IPoint[] }) =>
  polygonToRaster(payload.path),
)

action<DFSParams>(Actions.fillFromPointOnRaster, (payload: DFSParams) => runDFSScan(payload))
